import { render, staticRenderFns } from "./BrokerDetails.vue?vue&type=template&id=972becca&scoped=true&"
import script from "./BrokerDetails.vue?vue&type=script&lang=js&"
export * from "./BrokerDetails.vue?vue&type=script&lang=js&"
import style0 from "./BrokerDetails.vue?vue&type=style&index=0&id=972becca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "972becca",
  null
  
)

export default component.exports